import React, {useState, useEffect} from "react"
import FingerprintJS from "@fingerprintjs/fingerprintjs"

const FormHiddenFingerprint: React.FC = () => {
  const [visitorId, setVisitorId] = useState<string | null>(null)

  React.useEffect(() => {
    const setFp = async () => {
      const fp = await FingerprintJS.load()
      const {visitorId} = await fp.get()
      setVisitorId(visitorId)
    }

    setFp()
  }, [])

  return <input type="hidden" name="user[vid]" value={visitorId || ""} />
}

export default FormHiddenFingerprint
